import { useEffect, useState } from 'react';
import { api } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

function timeAgo(date) {
  const d=(Date.now()-new Date(date))/1000;
  if(d<60) return 'agora';
  if(d<3600) return Math.floor(d/60)+'min';
  if(d<86400) return Math.floor(d/3600)+'h';
  return Math.floor(d/86400)+'d';
}
function initials(nome) { return (nome||'?').split(' ').map(n=>n[0]).slice(0,2).join('').toUpperCase(); }
const COLORS = ['#EBF0FF','#E6F7F1','#FEF5E4','#FDEAEA','#F3E8FF'];
const TCOLORS = ['#1028A0','#0A6B47','#8C5E00','#922020','#5B21B6'];
const ci = (nome) => (nome||'').charCodeAt(0) % COLORS.length;

export default function MentorFeed() {
  const { token } = useAuth();
  const [posts, setPosts] = useState([]);
  const [novoPost, setNovoPost] = useState('');
  const [fixarMural, setFixarMural] = useState(false);
  const [publicando, setPublicando] = useState(false);
  const [editando, setEditando] = useState(null);
  const [textoEdit, setTextoEdit] = useState('');
  const [salvandoEdit, setSalvandoEdit] = useState(false);

  const load = () => api.get('/mentor/feed', token).then(setPosts);
  useEffect(() => { load(); }, [token]);

  const publicar = async (e) => {
    e.preventDefault();
    if (!novoPost.trim()) return;
    setPublicando(true);
    try {
      await api.post('/mentor/feed/publicar', { conteudo: novoPost, fixado: fixarMural }, token);
      setNovoPost(''); setFixarMural(false);
      await load();
    } finally { setPublicando(false); }
  };

  const remover = async (id) => {
    if (!window.confirm('Remover este post?')) return;
    await api.del(`/mentor/feed/${id}`, token);
    setPosts(prev => prev.filter(p => p.id !== id));
  };

  const toggleFixar = async (post) => {
    await api.patch(`/mentor/feed/${post.id}`, { fixado: !post.fixado }, token);
    await load();
  };

  const iniciarEdicao = (post) => { setEditando(post.id); setTextoEdit(post.conteudo); };

  const salvarEdicao = async (id) => {
    setSalvandoEdit(true);
    try {
      await api.patch(`/mentor/feed/${id}`, { conteudo: textoEdit }, token);
      await load(); setEditando(null);
    } finally { setSalvandoEdit(false); }
  };

  const postsFixados = posts.filter(p => p.fixado);
  const postsSemFixado = posts.filter(p => !p.fixado);

  return (
    <div style={{padding:'20px 32px'}}>
      <div style={{marginBottom:24}}>
        <div style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em'}}>Feed da Turma</div>
        <div style={{fontSize:13,color:'#6B7289',marginTop:3}}>{posts.length} publicações · visão e controle do mentor</div>
      </div>

      {/* Publicar */}
      <div className="card" style={{marginBottom:20,borderLeft:'3px solid #1A2ECC'}}>
        <div style={{fontSize:12,fontWeight:600,color:'#1A2ECC',marginBottom:10}}>📢 Publicar como Mentor</div>
        <form onSubmit={publicar}>
          <textarea className="input-field" rows={3}
            placeholder="Escreva um aviso, motivação ou comunicado para a turma..."
            value={novoPost} onChange={e=>setNovoPost(e.target.value)}
            style={{resize:'none',marginBottom:10}} />
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <label style={{display:'flex',alignItems:'center',gap:8,fontSize:13,color:'#3D4461',cursor:'pointer'}}>
              <input type="checkbox" checked={fixarMural} onChange={e=>setFixarMural(e.target.checked)} />
              📌 Fixar no mural dos alunos
            </label>
            <button className="btn-primary" type="submit" disabled={publicando||!novoPost.trim()}>
              {publicando?'Publicando...':'Publicar para a turma'}
            </button>
          </div>
        </form>
      </div>

      {/* Posts fixados */}
      {postsFixados && postsFixados.length > 0 && postsFixados.map(postFixado => (
        <div style={{background:'#FFFBEB',border:'1px solid #FDE68A',borderRadius:12,padding:16,marginBottom:16}}>
          <div style={{fontSize:11,fontWeight:700,color:'#92400E',marginBottom:8}}>📌 FIXADO NO MURAL</div>
          <div style={{fontSize:13,color:'#0B0E1A',lineHeight:1.6}}>{postFixado.conteudo}</div>
          <div style={{display:'flex',gap:8,marginTop:10}}>
            <button onClick={()=>toggleFixar(postFixado)}
              style={{fontSize:11,color:'#92400E',background:'#FEF3C7',border:'none',borderRadius:6,padding:'4px 10px',cursor:'pointer'}}>
              Desafixar
            </button>
            <button onClick={()=>remover(postFixado.id)}
              style={{fontSize:11,color:'#D63B3B',background:'#FDEAEA',border:'none',borderRadius:6,padding:'4px 10px',cursor:'pointer'}}>
              Remover
            </button>
          </div>
        </div>
      ))}

      {posts.length===0 && <div className="card" style={{textAlign:'center',padding:40,color:'#6B7289'}}><div style={{fontSize:24,marginBottom:8}}>💬</div>Nenhuma publicação ainda.</div>}

      {postsSemFixado.map(post => (
        <div key={post.id} className="card" style={{marginBottom:12,borderLeft:post.is_mentor?'3px solid #1A2ECC':'none'}}>
          <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:12}}>
            <div style={{width:36,height:36,borderRadius:10,
              background:post.is_mentor?'#1A2ECC':COLORS[ci(post.nome)],
              color:post.is_mentor?'#fff':TCOLORS[ci(post.nome)],
              display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:13,flexShrink:0}}>
              {post.is_mentor?'GB':initials(post.nome)}
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:600}}>
                {post.nome}
                {post.is_mentor && <span className="badge badge-blue" style={{marginLeft:6,fontSize:9}}>Mentor</span>}
                {post.turma && !post.is_mentor && <span className="badge" style={{marginLeft:6,fontSize:9,background:'#F4F5F9',color:'#6B7289'}}>{post.turma}</span>}
              </div>
              <div style={{fontSize:11,color:'#6B7289'}}>{timeAgo(post.criado_em)}</div>
            </div>
            <div style={{display:'flex',gap:6}}>
              <button onClick={()=>toggleFixar(post)}
                style={{fontSize:11,color:'#92400E',background:'#FEF3C7',border:'none',borderRadius:6,padding:'4px 10px',cursor:'pointer'}}>
                📌 Fixar
              </button>
              <button onClick={()=>iniciarEdicao(post)}
                style={{fontSize:11,color:'#1A2ECC',background:'#EBF0FF',border:'none',borderRadius:6,padding:'4px 10px',cursor:'pointer'}}>
                Editar
              </button>
              <button onClick={()=>remover(post.id)}
                style={{fontSize:11,color:'#D63B3B',background:'#FDEAEA',border:'none',borderRadius:6,padding:'4px 10px',cursor:'pointer'}}>
                Remover
              </button>
            </div>
          </div>

          {editando===post.id ? (
            <div>
              <textarea value={textoEdit} onChange={e=>setTextoEdit(e.target.value)} rows={3}
                style={{width:'100%',fontSize:13,padding:'10px 12px',border:'1px solid #1A2ECC',borderRadius:8,resize:'none',outline:'none',fontFamily:'inherit',marginBottom:8,boxSizing:'border-box'}} />
              <div style={{display:'flex',gap:8}}>
                <button className="btn-primary" style={{fontSize:12,padding:'7px 14px'}} onClick={()=>salvarEdicao(post.id)} disabled={salvandoEdit}>
                  {salvandoEdit?'Salvando...':'Salvar'}
                </button>
                <button className="btn-ghost" style={{fontSize:12,padding:'7px 14px'}} onClick={()=>setEditando(null)}>Cancelar</button>
              </div>
            </div>
          ) : (
            <div style={{fontSize:13,lineHeight:1.6,color:'#0B0E1A',marginBottom:12}}>{post.conteudo}</div>
          )}

          {editando!==post.id && (
            <div style={{display:'flex',gap:16,fontSize:12,color:'#6B7289',borderTop:'0.5px solid #E4E6EF',paddingTop:10}}>
              <span>❤️ {post.likes}</span>
              <span>💬 {post.comentarios}</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
